
/* SERVICE LIB */

import AuthorizationInfo from './service-lib/core/ace-authorization-info';

require('./service-lib/angular/application/application-module');
require('./service-lib/angular/application/application-configuration-service-angular');
require('./service-lib/angular/application/application-service-angular');
require('./service-lib/angular/application/editor-service-angular');

require('./service-lib/angular/authentication/authentication-module');
require('./service-lib/angular/authentication/ace-ui-auth');
require('./service-lib/angular/authentication/authentication-dialog');
require('./service-lib/angular/authentication/cognito-modal');

require('./service-lib/angular/service/service-module');
require('./service-lib/angular/service/authentication-service-angular');
require('./service-lib/angular/service/authorization-service-angular');
require('./service-lib/angular/service/clipboard-service-angular');
require('./service-lib/angular/service/cognito-service-angular');
require('./service-lib/angular/service/content-event-service-angular');
require('./service-lib/angular/service/content-service-angular');
require('./service-lib/angular/service/content-state-service-angular');
require('./service-lib/angular/service/error-messaging-service-angular');
require('./service-lib/angular/service/file-delivery-service-angular');
require('./service-lib/angular/service/file-service-angular');
require('./service-lib/angular/service/localization-service-angular');
require('./service-lib/angular/service/image-service-angular');
require('./service-lib/angular/service/keyboard-shortcut-service-angular');
require('./service-lib/angular/service/metadata-branch-service-angular');
require('./service-lib/angular/service/preview-service-angular');
require('./service-lib/angular/service/contenturl-service-angular');
require('./service-lib/angular/service/search-service-angular');
require('./service-lib/angular/service/security-user-service-angular');
require('./service-lib/angular/service/security-role-service-angular');
require('./service-lib/angular/service/type-service-angular');
require('./service-lib/angular/service/structure-service-angular');
require('./service-lib/angular/service/template-service-angular');
require('./service-lib/angular/service/user-data-service-angular');
require('./service-lib/angular/service/validation-service-angular');
require('./service-lib/angular/service/view-service-angular');
require('./service-lib/angular/service/webview-service-angular');
require('./service-lib/angular/service/workflow-service-angular');
require('./service-lib/angular/service/workspace-service-angular');
require('./service-lib/angular/service/taxonomy-service-angular');
require('./service-lib/angular/service/image-metadata-service-angular');

require('./service-lib/angular/ui/ui-module');
require('./service-lib/angular/ui/popover-directive');

require('./service-lib/core/error');
require('./service-lib/core/common');
require('./service-lib/core/content');

require('./service-lib/core/service/authentication-service');
require('./service-lib/core/service/cognito-service');
require('./service-lib/core/service/configuration-service');
require('./service-lib/core/service/content-service');
require('./service-lib/core/service/content-state-service');
require('./service-lib/core/service/file-delivery-service');
require('./service-lib/core/service/file-service');
require('./service-lib/core/service/localization-service');
require('./service-lib/core/service/image-service');
require('./service-lib/core/service/permission-service');
require('./service-lib/core/service/search-service');
require('./service-lib/core/service/security-user-service');
require('./service-lib/core/service/security-role-service');
require('./service-lib/core/service/type-service');
require('./service-lib/core/service/structure-service');
require('./service-lib/core/service/user-data-service');
require('./service-lib/core/service/view-service');
require('./service-lib/core/service/workspace-service');
require('./service-lib/core/service/workflow-service');
require('./service-lib/core/service/taxonomy-service');
require('./service-lib/core/service/image-metadata-service');

/* UI FRAMEWORK */

require('./framework/angular/ui/framework/aceui-content-editor-directive');
require('./framework/angular/ui/framework/template-field-directive');
require('./framework/angular/ui/framework/widget-service');
require('./framework/angular/ui/framework/message-bar-component');

require('./framework/angular/ui/widgets/widgets-module');

require('./framework/core/domain/domain-object');
require('./framework/core/domain/domain-object-factory');
require('./framework/core/domain/domain-object-service');

const aceui = atex.aceui;

atex.aceui.AuthorizationInfo = AuthorizationInfo;

export {
  aceui
};
